// AppForge Studio — Contenuti modificabili (IT / EN)
// Modifica qui testi, prezzi, servizi, portfolio, FAQ, testimonianze e CTA.

export const CONTACTS = {
  phone: "3493378898",
  phoneDisplay: "+39 349 337 8898",
  email: "giuseppe.settannix@gmail.com",
  whatsapp: "393493378898",
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
  linkedin: "https://linkedin.com",
};

export const NAV = {
  it: [
    { id: "soluzioni", label: "Soluzioni" },
    { id: "app", label: "App Prenotazioni" },
    { id: "landing", label: "Landing Page" },
    { id: "servizi", label: "Altri Servizi" },
    { id: "portfolio", label: "Portfolio" },
    { id: "processo", label: "Processo" },
    { id: "prezzi", label: "Prezzi" },
    { id: "faq", label: "FAQ" },
    { id: "contatti", label: "Contatti" },
  ],
  en: [
    { id: "soluzioni", label: "Solutions" },
    { id: "app", label: "Booking App" },
    { id: "landing", label: "Landing Page" },
    { id: "servizi", label: "Services" },
    { id: "portfolio", label: "Portfolio" },
    { id: "processo", label: "Process" },
    { id: "prezzi", label: "Pricing" },
    { id: "faq", label: "FAQ" },
    { id: "contatti", label: "Contact" },
  ],
};

export const CONTENT = {
  it: {
    brandTagline: "Software House",
    ctaConsult: "Consulenza gratuita",
    ctaDemo: "Vedi la demo",
    ctaQuote: "Richiedi preventivo",
    solutions: {
      label: "Le nostre soluzioni",
      title: "Soluzioni digitali per ogni esigenza",
      subtitle: "Scopri i principali servizi con cui aiutiamo aziende e professionisti a crescere.",
      discover: "Scopri di più",
      items: [
        { icon: "CalendarCheck", t: "App di Prenotazione", d: "Gestisci appuntamenti, clienti e calendario online, 24 ore su 24.", target: "app" },
        { icon: "Rocket", t: "Landing Page Professionali", d: "Pagine veloci e persuasive pensate per convertire i visitatori in contatti.", target: "landing" },
        { icon: "Code", t: "Software Personalizzati", d: "Soluzioni su misura costruite intorno ai processi del tuo business.", target: "servizi" },
        { icon: "Globe", t: "Siti Web Aziendali", d: "Una presenza online professionale, moderna e velocissima.", target: "servizi" },
      ],
    },
    help: {
      label: "Come possiamo aiutarti",
      title: "Da dove vuoi partire?",
      cta: "Contattaci",
      items: [
        { icon: "Lightbulb", t: "Hai un'idea da sviluppare?", d: "Trasformiamo la tua idea in un prodotto digitale concreto, funzionante e scalabile." },
        { icon: "TrendUp", t: "Vuoi digitalizzare la tua attività?", d: "Automatizziamo i processi e portiamo online la tua attività con strumenti su misura." },
        { icon: "PuzzlePiece", t: "Cerchi un software su misura?", d: "Progettiamo software personalizzati sulle tue esigenze specifiche, senza compromessi." },
      ],
    },
    finalCta: {
      title: "Pronto a far crescere la tua attività?",
      subtitle: "Raccontaci il tuo progetto: analizziamo le tue esigenze e ti proponiamo la soluzione migliore, senza impegno.",
      cta1: "Prenota una consulenza gratuita",
      cta2: "Richiedi un preventivo",
    },
    whyBadges: ["Software completamente personalizzati", "Nessun template standard", "Codice pulito e professionale", "Alte prestazioni", "Soluzioni scalabili", "Design moderno", "Supporto continuo", "Aggiornamenti costanti", "Esperienza utente ottimizzata", "Consulenza dedicata"],
    hero: {
      badge: "Software House Italiana",
      titleLines: ["Software su misura", "per aziende che", "vogliono lavorare meglio."],
      subtitle:
        "Dalle app di prenotazione ai software gestionali, dalle landing page ai sistemi completamente personalizzati: sviluppiamo soluzioni digitali pensate per semplificare il lavoro e far crescere il tuo business.",
      stats: [
        { value: "100%", label: "Su misura" },
        { value: "8", label: "Fasi di lavoro" },
        { value: "24/7", label: "Assistenza" },
      ],
    },
    marquee: ["React", "Python", "Node.js", "MongoDB", "AWS Cloud", "PWA", "FastAPI", "UX/UI Design", "API Integration"],
    app: {
      label: "Prodotto di punta",
      title: "App di prenotazione online per attività e professionisti",
      subtitle:
        "Una soluzione completa per gestire appuntamenti, clienti e calendario in modo semplice, veloce e professionale.",
      intro:
        "Ricevi prenotazioni online, organizza gli appuntamenti, visualizza il calendario, gestisci clienti e orari, riduci chiamate e messaggi inutili, automatizza il flusso di lavoro e offri un'esperienza moderna ai tuoi clienti.",
      demoCta: "Prova la demo",
      features: [
        "Prenotazione online", "Calendario appuntamenti", "Gestione clienti", "Area amministratore",
        "Gestione disponibilità", "Conferme automatiche", "Promemoria", "Storico prenotazioni",
        "Statistiche", "Accesso da smartphone", "Design responsive", "Installabile come PWA",
        "Personalizzazione grafica", "Logo e colori personalizzati", "Dominio personalizzato", "Evoluzioni future",
      ],
      idealTitle: "Ideale per",
      ideal: ["Parrucchieri", "Barbieri", "Centri estetici", "Nail salon", "Palestre", "Dentisti",
        "Studi medici", "Consulenti", "Hotel", "B&B", "Officine", "Professionisti", "Attività locali"],
      priceLabel: "A partire da",
      priceNote: "una tantum",
      monthlyNote: "Manutenzione, assistenza e aggiornamenti",
      priceExplain: [
        "Il costo iniziale copre sviluppo e configurazione completa.",
        "Il canone mensile copre assistenza, manutenzione, aggiornamenti e supporto continuativo.",
        "Il progetto può essere personalizzato ed evoluto nel tempo.",
      ],
      cta1: "Richiedi la tua app di prenotazione",
      cta2: "Prenota una demo",
    },
    landing: {
      label: "Conversione",
      title: "Landing page progettate per convertire",
      subtitle: "Pagine veloci, persuasive e ottimizzate per trasformare visitatori in contatti.",
      useCases: ["Promozione servizi", "Raccolta contatti", "Campagne pubblicitarie", "Presentazione aziendale",
        "Lancio prodotti", "Eventi", "Offerte e promozioni"],
      benefits: ["Struttura orientata alla conversione", "Design professionale", "SEO di base", "Caricamento veloce",
        "Responsive perfetto", "CTA efficaci", "Moduli contatto", "Integrazione WhatsApp", "Mappe e social",
        "Animazioni eleganti", "Tracking e analisi"],
      priceLabel: "A partire da",
      cta1: "Richiedi una landing page",
      cta2: "Vedi un esempio",
    },
    services: {
      label: "Non solo prenotazioni",
      title: "Sviluppiamo soluzioni digitali su misura",
      subtitle: "Se hai un'esigenza specifica, possiamo progettare il software adatto al tuo business.",
      note: "L'elenco rappresenta solo una parte delle soluzioni offerte. AppForge Studio sviluppa anche software completamente personalizzati su richiesta. Per qualsiasi progetto non presente tra i servizi elencati, contattaci per ricevere maggiori informazioni e una consulenza dedicata.",
      cta: "Hai un'idea? Possiamo trasformarla in software.",
      items: [
        { icon: "Globe", t: "Siti web aziendali", d: "Presenza online professionale e veloce." },
        { icon: "Gear", t: "Software gestionali", d: "Gestisci processi e operazioni in un unico posto." },
        { icon: "UsersThree", t: "CRM personalizzati", d: "Organizza clienti, lead e relazioni commerciali." },
        { icon: "ChartLineUp", t: "Dashboard & pannelli", d: "Controllo dati e KPI in tempo reale." },
        { icon: "UserCircleGear", t: "Portali clienti", d: "Aree riservate sicure per i tuoi clienti." },
        { icon: "DeviceMobile", t: "PWA installabili", d: "App web installabili su ogni dispositivo." },
        { icon: "ShoppingCart", t: "E-commerce", d: "Vendi online con soluzioni scalabili." },
        { icon: "Robot", t: "Automazioni digitali", d: "Elimina attività ripetitive e manuali." },
        { icon: "Buildings", t: "Gestione interna", d: "Strumenti su misura per il tuo team." },
        { icon: "Package", t: "Gestione magazzino", d: "Scorte, movimenti e inventario sotto controllo." },
        { icon: "FileText", t: "Gestione documentale", d: "Archivia e organizza documenti in modo smart." },
        { icon: "PresentationChart", t: "Report & analytics", d: "Decisioni guidate dai dati." },
        { icon: "Users", t: "App interne per team", d: "Collaborazione e produttività per il team." },
        { icon: "Code", t: "Software custom", d: "Sviluppo completamente su misura." },
        { icon: "PlugsConnected", t: "Integrazioni API", d: "Colleghiamo i tuoi strumenti tra loro." },
        { icon: "Cloud", t: "Soluzioni cloud", d: "Infrastrutture scalabili e affidabili." },
      ],
    },
    portfolio: {
      label: "Portfolio & Demo",
      title: "Progetti in evidenza",
      subtitle: "La demo dell'app di prenotazione è il nostro primo progetto in evidenza. Altri casi studio in arrivo.",
      items: [
        { t: "App Prenotazioni — Demo", cat: "Booking App / PWA", d: "Sistema completo di prenotazioni online con area admin, calendario e statistiche.", featured: true },
        { t: "In arrivo", cat: "Gestionale", d: "Nuovo caso studio in fase di pubblicazione.", featured: false },
        { t: "In arrivo", cat: "E-commerce", d: "Nuovo caso studio in fase di pubblicazione.", featured: false },
      ],
      viewCase: "Apri il progetto",
    },
    why: {
      label: "Perché AppForge Studio",
      title: "Superiore alle soluzioni standard",
      items: [
        { t: "Sviluppo su misura", d: "Nessun template generico: costruiamo per te." },
        { t: "Design moderno", d: "Interfacce eleganti, curate e attuali." },
        { t: "Soluzioni scalabili", d: "Software che cresce con la tua attività." },
        { t: "Supporto continuo", d: "Assistenza e aggiornamenti nel tempo." },
        { t: "Esperienza multi-settore", d: "Competenza su ambiti diversi." },
        { t: "Comunicazione chiara", d: "Ti seguiamo passo dopo passo." },
        { t: "Orientati ai risultati", d: "Obiettivi concreti e misurabili." },
        { t: "Attenzione al dettaglio", d: "Qualità percepita alta in ogni pixel." },
      ],
    },
    process: {
      label: "Come lavoriamo",
      title: "Ordine, metodo e affidabilità",
      steps: [
        { t: "Contatto iniziale", d: "Ci racconti la tua esigenza e i tuoi obiettivi." },
        { t: "Analisi delle esigenze", d: "Studiamo il progetto e definiamo le priorità." },
        { t: "Proposta e struttura", d: "Ti presentiamo soluzione, tempi e struttura." },
        { t: "Progettazione UX/UI", d: "Disegniamo un'esperienza chiara e premium." },
        { t: "Sviluppo", d: "Costruiamo il software con codice pulito." },
        { t: "Test e revisione", d: "Verifichiamo qualità, performance e dettagli." },
        { t: "Pubblicazione", d: "Mettiamo online la soluzione, pronta all'uso." },
        { t: "Assistenza continua", d: "Supporto, manutenzione ed evoluzioni." },
      ],
    },
    pricing: {
      label: "Prezzi",
      title: "Modello commerciale chiaro",
      note: "Ogni progetto viene definito in base alle funzionalità richieste e al livello di personalizzazione necessario.",
      plans: [
        { name: "App di prenotazione", highlight: true, priceKey: "app", suffix: "una tantum", monthly: true,
          features: ["Sviluppo e configurazione", "Area admin & calendario", "PWA installabile", "Personalizzazione grafica"] },
        { name: "Landing page", highlight: false, priceKey: "landing", suffix: "a partire da", monthly: false,
          features: ["Design orientato alla conversione", "SEO di base", "Responsive perfetto", "Moduli e integrazioni"] },
        { name: "Software personalizzati", highlight: false, custom: true, monthly: false,
          features: ["Analisi dedicata", "Soluzione su misura", "Integrazioni API", "Scalabilità cloud"] },
      ],
      customLabel: "Preventivo su misura",
      cta: "Richiedi un preventivo",
    },
    testimonials: {
      label: "Testimonianze",
      title: "La fiducia dei nostri clienti",
      items: [
        { name: "Marco R.", role: "Titolare, Barber Shop", text: "L'app di prenotazione ha ridotto le chiamate del 70%. Clienti soddisfatti e agenda sempre organizzata." },
        { name: "Giulia B.", role: "Centro estetico", text: "Design curato e assistenza impeccabile. Finalmente uno strumento su misura per la mia attività." },
        { name: "Andrea T.", role: "Studio di consulenza", text: "Hanno sviluppato un gestionale perfetto per il nostro flusso di lavoro. Professionali e precisi." },
      ],
    },
    faq: {
      label: "FAQ",
      title: "Domande frequenti",
      items: [
        { q: "Quanto costa un'app di prenotazione?", a: "L'app di prenotazione parte da 499 € una tantum, più un canone mensile di 29 €/mese per manutenzione, assistenza e aggiornamenti. Il prezzo finale dipende dalle personalizzazioni richieste." },
        { q: "Il prezzo iniziale include tutto?", a: "Il costo iniziale copre lo sviluppo e la configurazione completa della soluzione. Eventuali funzionalità avanzate o personalizzazioni specifiche vengono definite insieme." },
        { q: "Cosa comprende il canone mensile?", a: "Assistenza continuativa, manutenzione, aggiornamenti e supporto. In questo modo la tua soluzione resta sempre aggiornata e funzionante." },
        { q: "Quanto tempo serve per realizzare un progetto?", a: "Dipende dalla complessità. Dopo l'analisi delle esigenze ti forniamo tempistiche chiare e realistiche." },
        { q: "Le soluzioni sono personalizzabili?", a: "Sì, ogni progetto è costruito su misura: logo, colori, funzionalità e dominio personalizzato." },
        { q: "Posso avere un dominio dedicato?", a: "Certo. Configuriamo il tuo dominio personalizzato per un'immagine professionale." },
        { q: "Offrite assistenza dopo la pubblicazione?", a: "Sì, offriamo assistenza continua tramite il servizio mensile e siamo sempre disponibili per evoluzioni future." },
        { q: "Potete realizzare altri tipi di software oltre alle prenotazioni?", a: "Assolutamente sì: gestionali, CRM, dashboard, portali, e-commerce, PWA e molto altro. Contattaci per la tua esigenza specifica." },
        { q: "Posso aggiungere nuove funzionalità in futuro?", a: "Sì, le nostre soluzioni sono scalabili e possono evolvere nel tempo in base alle tue necessità." },
        { q: "Potete sviluppare software completamente personalizzati?", a: "Sì, sviluppiamo software totalmente su misura in base alle esigenze del cliente. Raccontaci il tuo progetto." },
        { q: "Realizzate anche prompt professionali e soluzioni basate sull'intelligenza artificiale?", a: "Sì, su richiesta realizziamo prompt professionali e soluzioni basate su AI. Contattaci tramite la sezione Contatti per una consulenza dedicata." },
      ],
    },
    contact: {
      label: "Contatti",
      title: "Parliamo del tuo progetto",
      highlight: "Non trovi il servizio che stai cercando? Nessun problema. AppForge Studio sviluppa anche software completamente personalizzati, gestionali, piattaforme web, applicazioni aziendali, strumenti basati sull'intelligenza artificiale e prompt professionali realizzati su richiesta. Raccontaci il tuo progetto: analizzeremo le tue esigenze e ti proporremo la soluzione migliore.",
      trust: "Consulenza gratuita e senza impegno. Ti rispondiamo entro 24 ore.",
      fields: { nome: "Nome", cognome: "Cognome", email: "Email", telefono: "Telefono", azienda: "Azienda",
        servizio: "Servizio richiesto", budget: "Budget indicativo", descrizione: "Descrizione del progetto" },
      servizioOptions: ["App di prenotazione", "Landing page", "Sito web aziendale", "Software gestionale", "CRM", "E-commerce", "Soluzione AI / Prompt", "Altro / Software custom"],
      budgetOptions: ["< 500 €", "500 € - 1.500 €", "1.500 € - 5.000 €", "> 5.000 €", "Da definire"],
      submit: "Invia richiesta",
      sending: "Invio in corso...",
      success: "Richiesta inviata! Ti contatteremo al più presto.",
      error: "Si è verificato un errore. Riprova o scrivici via email.",
      quickTitle: "Contatti rapidi",
    },
    footer: {
      desc: "Software house italiana specializzata nello sviluppo di soluzioni digitali personalizzate per aziende, attività locali e professionisti.",
      quickLinks: "Link rapidi",
      legal: "Legale",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      terms: "Termini e Condizioni",
      rights: "Tutti i diritti riservati.",
      admin: "Area riservata",
    },
  },

  en: {
    brandTagline: "Software House",
    ctaConsult: "Free consultation",
    ctaDemo: "View demo",
    ctaQuote: "Request a quote",
    solutions: {
      label: "Our solutions",
      title: "Digital solutions for every need",
      subtitle: "Discover the main services we use to help businesses and professionals grow.",
      discover: "Learn more",
      items: [
        { icon: "CalendarCheck", t: "Booking App", d: "Manage appointments, clients and calendar online, 24/7.", target: "app" },
        { icon: "Rocket", t: "Professional Landing Pages", d: "Fast, persuasive pages designed to turn visitors into leads.", target: "landing" },
        { icon: "Code", t: "Custom Software", d: "Tailored solutions built around your business processes.", target: "servizi" },
        { icon: "Globe", t: "Business Websites", d: "A professional, modern and lightning-fast online presence.", target: "servizi" },
      ],
    },
    help: {
      label: "How we can help",
      title: "Where do you want to start?",
      cta: "Contact us",
      items: [
        { icon: "Lightbulb", t: "Have an idea to develop?", d: "We turn your idea into a concrete, working and scalable digital product." },
        { icon: "TrendUp", t: "Want to digitalize your business?", d: "We automate processes and bring your business online with tailored tools." },
        { icon: "PuzzlePiece", t: "Looking for custom software?", d: "We design custom software around your specific needs, no compromises." },
      ],
    },
    finalCta: {
      title: "Ready to grow your business?",
      subtitle: "Tell us about your project: we analyze your needs and propose the best solution, with no obligation.",
      cta1: "Book a free consultation",
      cta2: "Request a quote",
    },
    whyBadges: ["Fully custom software", "No standard templates", "Clean, professional code", "High performance", "Scalable solutions", "Modern design", "Continuous support", "Constant updates", "Optimized user experience", "Dedicated consultation"],
    hero: {
      badge: "Italian Software House",
      titleLines: ["Custom software", "for businesses that", "want to work better."],
      subtitle:
        "From booking apps to management software, from landing pages to fully custom systems: we build digital solutions designed to simplify work and grow your business.",
      stats: [
        { value: "100%", label: "Tailored" },
        { value: "8", label: "Work phases" },
        { value: "24/7", label: "Support" },
      ],
    },
    marquee: ["React", "Python", "Node.js", "MongoDB", "AWS Cloud", "PWA", "FastAPI", "UX/UI Design", "API Integration"],
    app: {
      label: "Flagship product",
      title: "Online booking app for businesses and professionals",
      subtitle: "A complete solution to manage appointments, clients and calendar in a simple, fast and professional way.",
      intro: "Receive online bookings, organize appointments, view the calendar, manage clients and hours, reduce unnecessary calls, automate your workflow and offer a modern experience to your customers.",
      demoCta: "Try the demo",
      features: [
        "Online booking", "Appointment calendar", "Client management", "Admin area",
        "Availability management", "Automatic confirmations", "Reminders", "Booking history",
        "Statistics", "Mobile access", "Responsive design", "Installable as PWA",
        "Graphic customization", "Custom logo & colors", "Custom domain", "Future evolutions",
      ],
      idealTitle: "Ideal for",
      ideal: ["Hairdressers", "Barbers", "Beauty centers", "Nail salons", "Gyms", "Dentists",
        "Medical practices", "Consultants", "Hotels", "B&B", "Workshops", "Professionals", "Local businesses"],
      priceLabel: "Starting from",
      priceNote: "one-off",
      monthlyNote: "Maintenance, support and updates",
      priceExplain: [
        "The initial cost covers development and full setup.",
        "The monthly fee covers support, maintenance, updates and ongoing assistance.",
        "The project can be customized and evolved over time.",
      ],
      cta1: "Request your booking app",
      cta2: "Book a demo",
    },
    landing: {
      label: "Conversion",
      title: "Landing pages designed to convert",
      subtitle: "Fast, persuasive pages optimized to turn visitors into leads.",
      useCases: ["Service promotion", "Lead generation", "Ad campaigns", "Company presentation",
        "Product launch", "Events", "Offers and promotions"],
      benefits: ["Conversion-oriented structure", "Professional design", "Basic SEO", "Fast loading",
        "Perfect responsive", "Effective CTAs", "Contact forms", "WhatsApp integration", "Maps and social",
        "Elegant animations", "Tracking and analytics"],
      priceLabel: "Starting from",
      cta1: "Request a landing page",
      cta2: "See an example",
    },
    services: {
      label: "Not just bookings",
      title: "We build custom digital solutions",
      subtitle: "If you have a specific need, we can design the right software for your business.",
      note: "This list represents only part of the solutions we offer. AppForge Studio also develops fully custom software on request. For any project not listed among our services, contact us for more information and a dedicated consultation.",
      cta: "Have an idea? We can turn it into software.",
      items: [
        { icon: "Globe", t: "Business websites", d: "Professional and fast online presence." },
        { icon: "Gear", t: "Management software", d: "Manage processes and operations in one place." },
        { icon: "UsersThree", t: "Custom CRM", d: "Organize clients, leads and relationships." },
        { icon: "ChartLineUp", t: "Dashboards & panels", d: "Real-time data and KPI control." },
        { icon: "UserCircleGear", t: "Client portals", d: "Secure private areas for your clients." },
        { icon: "DeviceMobile", t: "Installable PWA", d: "Web apps installable on any device." },
        { icon: "ShoppingCart", t: "E-commerce", d: "Sell online with scalable solutions." },
        { icon: "Robot", t: "Digital automations", d: "Eliminate repetitive manual tasks." },
        { icon: "Buildings", t: "Internal management", d: "Custom tools for your team." },
        { icon: "Package", t: "Warehouse management", d: "Stock, movements and inventory under control." },
        { icon: "FileText", t: "Document management", d: "Store and organize documents smartly." },
        { icon: "PresentationChart", t: "Reports & analytics", d: "Data-driven decisions." },
        { icon: "Users", t: "Internal team apps", d: "Collaboration and productivity for teams." },
        { icon: "Code", t: "Custom software", d: "Fully tailored development." },
        { icon: "PlugsConnected", t: "API integrations", d: "We connect your tools together." },
        { icon: "Cloud", t: "Cloud solutions", d: "Scalable and reliable infrastructure." },
      ],
    },
    portfolio: {
      label: "Portfolio & Demo",
      title: "Featured projects",
      subtitle: "The booking app demo is our first featured project. More case studies coming soon.",
      items: [
        { t: "Booking App — Demo", cat: "Booking App / PWA", d: "Complete online booking system with admin area, calendar and statistics.", featured: true },
        { t: "Coming soon", cat: "Management", d: "New case study being published.", featured: false },
        { t: "Coming soon", cat: "E-commerce", d: "New case study being published.", featured: false },
      ],
      viewCase: "Open project",
    },
    why: {
      label: "Why AppForge Studio",
      title: "Superior to standard solutions",
      items: [
        { t: "Tailored development", d: "No generic templates: we build for you." },
        { t: "Modern design", d: "Elegant, refined and current interfaces." },
        { t: "Scalable solutions", d: "Software that grows with your business." },
        { t: "Continuous support", d: "Assistance and updates over time." },
        { t: "Multi-sector experience", d: "Expertise across different fields." },
        { t: "Clear communication", d: "We guide you step by step." },
        { t: "Results-oriented", d: "Concrete and measurable goals." },
        { t: "Attention to detail", d: "High perceived quality in every pixel." },
      ],
    },
    process: {
      label: "How we work",
      title: "Order, method and reliability",
      steps: [
        { t: "First contact", d: "Tell us your need and your goals." },
        { t: "Needs analysis", d: "We study the project and define priorities." },
        { t: "Proposal & structure", d: "We present solution, timeline and structure." },
        { t: "UX/UI design", d: "We design a clear and premium experience." },
        { t: "Development", d: "We build the software with clean code." },
        { t: "Testing & review", d: "We check quality, performance and details." },
        { t: "Launch", d: "We put the solution online, ready to use." },
        { t: "Ongoing support", d: "Support, maintenance and evolutions." },
      ],
    },
    pricing: {
      label: "Pricing",
      title: "Clear commercial model",
      note: "Each project is defined based on the required features and the level of customization needed.",
      plans: [
        { name: "Booking app", highlight: true, priceKey: "app", suffix: "one-off", monthly: true,
          features: ["Development and setup", "Admin area & calendar", "Installable PWA", "Graphic customization"] },
        { name: "Landing page", highlight: false, priceKey: "landing", suffix: "starting from", monthly: false,
          features: ["Conversion-oriented design", "Basic SEO", "Perfect responsive", "Forms and integrations"] },
        { name: "Custom software", highlight: false, custom: true, monthly: false,
          features: ["Dedicated analysis", "Tailored solution", "API integrations", "Cloud scalability"] },
      ],
      customLabel: "Custom quote",
      cta: "Request a quote",
    },
    testimonials: {
      label: "Testimonials",
      title: "The trust of our clients",
      items: [
        { name: "Marco R.", role: "Owner, Barber Shop", text: "The booking app cut calls by 70%. Happy clients and an always-organized schedule." },
        { name: "Giulia B.", role: "Beauty center", text: "Refined design and impeccable support. Finally a tool tailored to my business." },
        { name: "Andrea T.", role: "Consulting firm", text: "They built a management tool perfect for our workflow. Professional and precise." },
      ],
    },
    faq: {
      label: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "How much does a booking app cost?", a: "The booking app starts from €499 one-off, plus a €29/month fee for maintenance, support and updates. The final price depends on requested customizations." },
        { q: "Does the initial price include everything?", a: "The initial cost covers full development and setup. Advanced features or specific customizations are defined together." },
        { q: "What does the monthly fee include?", a: "Ongoing support, maintenance, updates and assistance. This keeps your solution always up to date and working." },
        { q: "How long does a project take?", a: "It depends on complexity. After the needs analysis we provide clear and realistic timelines." },
        { q: "Are the solutions customizable?", a: "Yes, every project is tailor-made: logo, colors, features and custom domain." },
        { q: "Can I have a dedicated domain?", a: "Of course. We configure your custom domain for a professional image." },
        { q: "Do you offer support after launch?", a: "Yes, we offer continuous support through the monthly service and we are always available for future evolutions." },
        { q: "Can you build other types of software besides bookings?", a: "Absolutely: management software, CRM, dashboards, portals, e-commerce, PWA and much more. Contact us for your specific need." },
        { q: "Can I add new features in the future?", a: "Yes, our solutions are scalable and can evolve over time based on your needs." },
        { q: "Can you develop fully custom software?", a: "Yes, we develop fully tailored software based on client needs. Tell us about your project." },
        { q: "Do you also create professional prompts and AI-based solutions?", a: "Yes, on request we create professional prompts and AI-based solutions. Contact us for a dedicated consultation." },
      ],
    },
    contact: {
      label: "Contact",
      title: "Let's talk about your project",
      highlight: "Can't find the service you're looking for? No problem. AppForge Studio also develops fully custom software, management systems, web platforms, business applications, AI-based tools and professional prompts on request. Tell us about your project: we'll analyze your needs and propose the best solution.",
      trust: "Free, no-obligation consultation. We reply within 24 hours.",
      fields: { nome: "First name", cognome: "Last name", email: "Email", telefono: "Phone", azienda: "Company",
        servizio: "Requested service", budget: "Indicative budget", descrizione: "Project description" },
      servizioOptions: ["Booking app", "Landing page", "Business website", "Management software", "CRM", "E-commerce", "AI solution / Prompt", "Other / Custom software"],
      budgetOptions: ["< €500", "€500 - €1,500", "€1,500 - €5,000", "> €5,000", "To be defined"],
      submit: "Send request",
      sending: "Sending...",
      success: "Request sent! We'll contact you shortly.",
      error: "An error occurred. Please retry or email us.",
      quickTitle: "Quick contacts",
    },
    footer: {
      desc: "Italian software house specialized in developing custom digital solutions for businesses, local activities and professionals.",
      quickLinks: "Quick links",
      legal: "Legal",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      terms: "Terms & Conditions",
      rights: "All rights reserved.",
      admin: "Admin area",
    },
  },
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/13129482/pexels-photo-13129482.jpeg",
  appMockup: "https://images.pexels.com/photos/6373185/pexels-photo-6373185.jpeg",
  softwareDev: "https://images.pexels.com/photos/34803994/pexels-photo-34803994.jpeg",
  team: "https://images.pexels.com/photos/5473301/pexels-photo-5473301.jpeg",
  testimonialM: "https://images.pexels.com/photos/37218479/pexels-photo-37218479.jpeg",
  testimonialF: "https://images.pexels.com/photos/10040258/pexels-photo-10040258.jpeg",
};

export const COMPANY = {
  name: "AppForge Studio",
  legalName: "[Ragione sociale / Titolare]",  vat: "[P.IVA / C.F.]",
  address: "[Indirizzo, CAP, Città]",
  city: "[Città]",
  email: CONTACTS.email,
  phone: CONTACTS.phoneDisplay,
  pec: "[PEC]",
  lastUpdate: "[gg/mm/aaaa]",
};

export const COOKIE_BANNER = {
  it: {
    text: "Utilizziamo cookie tecnici necessari al funzionamento del sito ed eventuali cookie di analisi per migliorare la tua esperienza.",
    accept: "Accetta",
    reject: "Rifiuta",
    more: "Cookie Policy",
  },
  en: {
    text: "We use technical cookies necessary for the site to work and possibly analytics cookies to improve your experience.",
    accept: "Accept",
    reject: "Decline",
    more: "Cookie Policy",
  },
};

export const LEGAL = {
  it: {
    back: "Torna al sito",
    updated: "Ultimo aggiornamento",
    privacy: {
      slug: "privacy",
      title: "Privacy Policy",
      sections: [
        { h: "1. Titolare del trattamento", p: `Il titolare del trattamento dei dati è ${COMPANY.legalName} (${COMPANY.name}), con sede in ${COMPANY.address}, P.IVA ${COMPANY.vat}. Per qualsiasi richiesta è possibile scrivere a ${COMPANY.email}.` },
        { h: "2. Dati raccolti", p: "Raccogliamo i dati che ci fornisci volontariamente tramite il modulo di contatto (nome, cognome, email, telefono, azienda, servizio richiesto, budget e descrizione del progetto), oltre a dati tecnici di navigazione (es. cookie tecnici)." },
        { h: "3. Finalità del trattamento", p: "I dati vengono trattati per rispondere alle richieste di contatto e preventivo, fornire consulenza e gestire il rapporto con il cliente. Il conferimento è facoltativo, ma necessario per dare seguito alle richieste." },
        { h: "4. Base giuridica", p: "Il trattamento si basa sul consenso dell'interessato e sull'esecuzione di misure precontrattuali richieste dallo stesso." },
        { h: "5. Conservazione dei dati", p: "I dati sono conservati per il tempo strettamente necessario alle finalità indicate e nel rispetto degli obblighi di legge." },
        { h: "6. Diritti dell'interessato", p: "Hai diritto di accedere, rettificare, cancellare i tuoi dati, limitarne il trattamento e opporti allo stesso, scrivendo a " + COMPANY.email + "." },
        { h: "7. Modifiche", p: "La presente informativa può essere aggiornata nel tempo. Ti invitiamo a consultarla periodicamente." },
      ],
    },
    cookie: {
      slug: "cookie",
      title: "Cookie Policy",
      sections: [
        { h: "1. Cosa sono i cookie", p: "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva." },
        { h: "2. Cookie tecnici", p: "Il sito utilizza cookie tecnici necessari al corretto funzionamento e alla navigazione. Per questi cookie non è richiesto il consenso." },
        { h: "3. Cookie di terze parti / analitici", p: "Il sito potrebbe utilizzare strumenti di analisi per raccogliere informazioni aggregate sull'utilizzo. [Specificare eventuali strumenti utilizzati]." },
        { h: "4. Gestione dei cookie", p: "Puoi gestire o disabilitare i cookie tramite le impostazioni del tuo browser. La disabilitazione di alcuni cookie potrebbe compromettere alcune funzionalità del sito." },
      ],
    },
    terms: {
      slug: "termini",
      title: "Termini e Condizioni",
      sections: [
        { h: "1. Oggetto", p: `I presenti termini regolano l'utilizzo del sito e i servizi offerti da ${COMPANY.name}, tra cui sviluppo di software su misura, app di prenotazione, landing page e soluzioni digitali.` },
        { h: "2. Preventivi e prezzi", p: "I prezzi indicati sul sito sono indicativi e \"a partire da\". Ogni progetto viene definito tramite preventivo dedicato in base a funzionalità e personalizzazioni richieste." },
        { h: "3. Modalità di erogazione", p: "I servizi vengono erogati secondo quanto concordato in fase di preventivo. Tempi e modalità sono comunicati dopo l'analisi delle esigenze." },
        { h: "4. Proprietà intellettuale", p: "I contenuti del sito sono di proprietà di " + COMPANY.name + ". È vietata la riproduzione senza autorizzazione." },
        { h: "5. Limitazione di responsabilità", p: "[Inserire clausole di limitazione di responsabilità e foro competente in base ai dati definitivi.]" },
        { h: "6. Legge applicabile", p: "I presenti termini sono regolati dalla legge italiana. Foro competente: [Città]." },
      ],
    },
  },
  en: {
    back: "Back to site",
    updated: "Last updated",
    privacy: {
      slug: "privacy",
      title: "Privacy Policy",
      sections: [
        { h: "1. Data controller", p: `The data controller is ${COMPANY.legalName} (${COMPANY.name}), based in ${COMPANY.address}, VAT ${COMPANY.vat}. For any request write to ${COMPANY.email}.` },
        { h: "2. Data collected", p: "We collect the data you voluntarily provide through the contact form (first name, last name, email, phone, company, requested service, budget and project description), plus technical browsing data (e.g. technical cookies)." },
        { h: "3. Purpose", p: "Data is processed to respond to contact and quote requests, provide consultancy and manage the client relationship. Providing data is optional but necessary to follow up on requests." },
        { h: "4. Legal basis", p: "Processing is based on the data subject's consent and on pre-contractual measures requested by them." },
        { h: "5. Data retention", p: "Data is kept for the time strictly necessary for the stated purposes and in compliance with legal obligations." },
        { h: "6. Your rights", p: "You have the right to access, rectify, delete your data, restrict and object to processing, by writing to " + COMPANY.email + "." },
        { h: "7. Changes", p: "This policy may be updated over time. Please review it periodically." },
      ],
    },
    cookie: {
      slug: "cookie",
      title: "Cookie Policy",
      sections: [
        { h: "1. What cookies are", p: "Cookies are small text files that visited sites send to the user's device, where they are stored to be resent to the same sites on the next visit." },
        { h: "2. Technical cookies", p: "The site uses technical cookies necessary for proper operation and navigation. No consent is required for these cookies." },
        { h: "3. Third-party / analytics cookies", p: "The site may use analytics tools to collect aggregate usage information. [Specify any tools used]." },
        { h: "4. Managing cookies", p: "You can manage or disable cookies through your browser settings. Disabling some cookies may affect certain site features." },
      ],
    },
    terms: {
      slug: "termini",
      title: "Terms & Conditions",
      sections: [
        { h: "1. Subject", p: `These terms govern the use of the site and the services offered by ${COMPANY.name}, including custom software development, booking apps, landing pages and digital solutions.` },
        { h: "2. Quotes and prices", p: "Prices shown on the site are indicative and \"starting from\". Each project is defined through a dedicated quote based on requested features and customizations." },
        { h: "3. Service delivery", p: "Services are delivered as agreed at the quotation stage. Timing and methods are communicated after the needs analysis." },
        { h: "4. Intellectual property", p: "The site contents are property of " + COMPANY.name + ". Reproduction without authorization is prohibited." },
        { h: "5. Limitation of liability", p: "[Insert liability limitation clauses and competent court based on final data.]" },
        { h: "6. Applicable law", p: "These terms are governed by Italian law. Competent court: [City]." },
      ],
    },
  },
};
